export const domainMappings = {
  'admin.filewale.com': {
    appUrl: 'https://filewale.com',
    apiUrl: 'https://apis.filewale.com',
  },
  'admin-demo.shadowgrow.com': {
    appUrl: 'https://demo.shadowgrow.com',
    apiUrl: 'https://demo-api.shadowgrow.com',
  },
  'admin.zmtfirmwarefiles.com': {
    appUrl: 'https://zmtfirmwarefiles.com',
    apiUrl: 'https://api.zmtfirmwarefiles.com',
  },
  'admin.gsmfileguru.com': {
    appUrl: 'https://gsmfileguru.com',
    apiUrl: 'https://api.gsmfileguru.com',
  },
  'gsmraja-admin.shadowgrow.com': {
    appUrl: 'https://gsmraja.shadowgrow.com',
    apiUrl: 'https://gsmraja-api.shadowgrow.com',
  },
  'admin.gsmfilehub.in': {
    appUrl: 'https://gsmfilehub.in',
    apiUrl: 'https://api.gsmfilehub.in',
  },
  'admin.paidfirmware.com': {
    appUrl: 'https://paidfirmware.com',
    apiUrl: 'https://api.paidfirmware.com',
  },
  'admin-paidfirmware.vercel.app': {
    appUrl: 'https://paidfirmware.com',
    apiUrl: 'https://api.paidfirmware.com',
  },
  'manage.nanorom.in': {
    appUrl: 'https://nanorom.in',
    apiUrl: 'https://api.nanorom.in',
  },
  'admin.ultimatefirmware.com': {
    appUrl: 'https://ultimatefirmware.com',
    apiUrl: 'https://api.ultimatefirmware.com',
  },
  localhost: {
    appUrl: 'https://filewale.com',
    apiUrl: 'https://apis.filewale.com',
    // apiUrl: 'http://localhost:3005',
    // appUrl: 'http://localhost:3000',
  },
};
